import React, { useState } from 'react';
import ReactPlayer from 'react-player';

import { useAsset } from '../../../../../hooks/useAsset';
import type { Asset2Video } from '../../../../../models';
import { getPreviewUrl } from '../../../../AssetPreview/util';
import Loader from '../../../../Loader';
// import { XButton } from '../../atoms/XButton';
import { LoaderWrapper, PreviewPlaceholder, PreviewPlaceholderIcon, VideoContainer, VideoFigure } from './styles';

export const VideoPlayer: React.FC<{ asset: Asset2Video }> = ({ asset, children }) => {
  const { assetUrl, hasError } = useAsset({ url: getPreviewUrl(asset.id) });
  const [showControls, setShowControls] = useState<boolean>(false);

  return (
    <VideoFigure>
      {/* Removed X button for now until revisited if removal of asset is needed */}
      {/* <XButton /> */}
      {children}
      <VideoContainer>
        {hasError ? (
          <PreviewPlaceholder data-testid="video-player-error-placeholder">
            <PreviewPlaceholderIcon aria-label="preview unavailable icon" />
            <span>Preview unavailable</span>
          </PreviewPlaceholder>
        ) : !assetUrl ? (
          <>
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
            <video aria-label="video-player" controls src={`assetUrl`} />
          </>
        ) : (
          <ReactPlayer
            url={assetUrl}
            controls={showControls}
            onCanPlayThrough={(): void => {
              setShowControls(true);
            }}
            width={`100%`}
            height={`100%`}
          />
        )}
      </VideoContainer>
    </VideoFigure>
  );
};

/** Same footprint as VideoPlayer, but does not fetch the asset. Used until the preview is actually needed. */
export const VideoPlayerPlaceholder: React.FC = ({ children }) => (
  <VideoFigure data-testid="video-player-placeholder">
    {children}
    <VideoContainer>
      <video aria-label="video-preview-placeholder" />
    </VideoContainer>
  </VideoFigure>
);
